import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useLocationResourceStore } from '~/client/src/shared/hooks/useLocationResourceStore'
import { useResourceRuntimeContext } from '~/client/src/shared/hooks/useResourceRuntimeContext'

import { createResourceProvider } from '../../components/Resource/createResourceProvider'

export const LocationsProvider = createResourceProvider({
  resourceTypeId: ResourceTypeId.LOCATIONS,
  useSource: useLocationResourceStore,
  columnConfigKey: LocalStorageKey.LocationsColumnConfig,
  useRuntimeContext: useResourceRuntimeContext,
})
